import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLeave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M12.437 2.163c.146.127.23.31.23.504v18.666a.667.667 0 0 1-.761.66l-8.189-1.17A2 2 0 0 1 2 18.844V5.157a2 2 0 0 1 1.717-1.98l8.189-1.17a.667.667 0 0 1 .53.157Zm-1.77 9.17a.667.667 0 0 0-1.334 0v1.334a.667.667 0 1 0 1.334 0v-1.334Zm6.666 9.334H14v-1.334h3.333a.667.667 0 0 0 .667-.666v-1.334a.667.667 0 0 1 1.333 0v1.334a2 2 0 0 1-2 2ZM14 4.667V3.333h3.333a2 2 0 0 1 2 2v1.334a.667.667 0 1 1-1.333 0V5.333a.667.667 0 0 0-.667-.666H14Zm4.195 4.195c.26-.26.683-.26.943 0l2.667 2.667.01.01.005.006a.664.664 0 0 1-.017.928l-2.665 2.665a.667.667 0 0 1-.943-.943l1.529-1.528h-5.057a.667.667 0 0 1 0-1.334h5.057l-1.529-1.528a.667.667 0 0 1 0-.943Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLeave;
